import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import LawdocsFlow from './Document/LawdocsFlow';
import '../i18n';
const documentFlow = document.querySelector('#lawdocs-flow');
if (documentFlow) {
    const lawdocsServiceEndpoint = documentFlow.getAttribute('data-endpoint');
    const user = JSON.parse(documentFlow.getAttribute('data-user'));
    const product = documentFlow.getAttribute('data-product');
    const purchaseType = documentFlow.getAttribute('data-purchase-type');
    render(_jsx(LawdocsFlow, { user: user, type: product, endpoint: lawdocsServiceEndpoint, purchase_type: purchaseType }), documentFlow);
}
